import { openInNewTab } from "@helpers"
import axios from "axios"
import useGet from "./useGet"
import useStatic from "./useStatic"

export default function useController(resource: string) {
    const get = <T extends any = any>(url: string | number = "") => {
        const request = async (params?: object) => {
            const result = await axios.get<T>(endpoint(url), { params })
            return result.data
        }

        const use = (cacheId?: string) => {
            const { data, setData, status } = useGet<T>(endpoint(url), {
                cacheId
            })

            const fresh = async (params?: object) => {
                setData(await request(params))
            }

            return { data, setData, fresh, request, status }
        }

        return { use, request }
    }

    const post = async <T extends any = any>(url: string | number = "", data?: any) => {
        const result = await axios.post<T>(endpoint(url), data)
        return result.data
    }

    const patch = async <T extends any = any>(url: string | number = "", data?: any) => {
        const result = await axios({
            method: data instanceof FormData ? "post" : "patch",
            url: endpoint(url), 
            data
        })
        
        return result.data as T
    }

    const del = async <T extends any = any>(url: string | number = "") => {
        const result = await axios.delete<T>(endpoint(url))
        return result.data
    }

    const newTab = (url: string | number = "") => {
        openInNewTab(endpoint(url))
    }

    const endpoint = (url: string | number = "") => {
        return url ? (resource + '/' + url) : resource
    }

    return useStatic({ get, post, patch, del, newTab })
}